const merge = require('lodash/merge');
const parseRequestMetaData = require('../../utils/parse-request-meta-data');
const apiConfig = require('../../api-config');
const { Base64 } = require('js-base64');
const SEPERATOR = require('../../utils/constants');
const { decode } = require('base-64');

function apiFactory({
  baseUrl,
  requestHandler
}) {
  const headers = {
    Accept: 'application/json'
  };

  function getUrl(endpoint) {
    return `${baseUrl}${endpoint}`;
  }

  return {

    getConsentRequest(inputParam, metaData) {
      const url = getUrl('consents/fetch');
      const parsedMetaData = parseRequestMetaData(metaData);
      const reqOpts = {
        headers: merge(headers, parsedMetaData.headers),
        method: 'POST',
        json: true
      };
    
      const params = Base64.decode(inputParam);

      const body = {
        psuId: params,
        branchCode: apiConfig.branchCode,
        language: parsedMetaData.portfolio.language,
        //userId: parsedMetaData.qs.userId,

      }

      return requestHandler(merge(reqOpts, {
        url,
        body
      }));
    },

    getAISConsent(inputParam, metaData) {
      const url = getUrl('consents/ais/get');
      const parsedMetaData = parseRequestMetaData(metaData);
      const reqOpts = {
        headers: merge(headers, parsedMetaData.headers),
        method: 'POST',
        json: true
      };

      const params = inputParam.split(SEPERATOR.SEPERATOR);

      const body = {
        psuId: Base64.decode(params[0]),
        consentId: Base64.decode(params[1]),
        branchCode: apiConfig.branchCode,
        language: parsedMetaData.portfolio.language,

      }

      return requestHandler(merge(reqOpts, {
        url,
        body
      }));
    },

    consentUpdate(inputParam, metaData) {
      const url = getUrl('consents/ais/update');
      const parsedMetaData = parseRequestMetaData(metaData);
      const reqOpts = {
        headers: merge(headers, parsedMetaData.headers),
        method: 'POST',
        json: true
      };
      //JSON.parse(decode(base64DataObj));
      
      const params = inputParam.split(SEPERATOR.SEPERATOR);
      const body = {
        consent: JSON.parse(Base64.decode(params[0])).consent,
        branchCode: apiConfig.branchCode,
        language: parsedMetaData.portfolio.language, 
      }

      return requestHandler(merge(reqOpts, {
        url,
        body
      }));
    }
  };
}


module.exports = apiFactory;
